import { TabList } from "@headlessui/react";
import { NavigationTab } from "./NavigationTab";
import { useNavigationTabContext } from "./useNavigationTabContext";
import { twMerge } from "tailwind-merge";

export const NavigationTabList = ({
  variant = "underline",
}: {
  variant?: "underline" | "button";
}) => {
  const { tabs } = useNavigationTabContext();

  return (
    <TabList
      className={twMerge(
        "mx-auto flex max-w-[100vw] divide-x overflow-x-auto p-0 font-bold dark:divide-zinc-800",
        variant === "underline" && "",
        variant === "button" &&
          "w-full rounded-lg border border-zinc-300 bg-white dark:border-zinc-800 dark:bg-zinc-900",
      )}
    >
      {tabs.map((tab) => (
        <NavigationTab key={tab} variant={variant}>
          {tab}
        </NavigationTab>
      ))}
    </TabList>
  );
};
